export const projects = [
    {
        id: 1,
        projectName: "RAJPATH ENCLAVE",
        projectImages: [
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025175145.jpeg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025175342.jpeg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025175401.jpeg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025175433.jpeg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025223910.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025223946.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025235208.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025235246.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025235320.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025235352.jpg",
        ]
    },
    {
        id: 2,
        projectName: "RAJPATH GRAND",
        projectImages: [
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025224445.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025224510.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025224535.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025224612.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025224654.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025224717.jpg"
        ]
    },
    {
        id: 3,
        projectName: "THE RIVER CASTLE PH-1",
        projectImages: [
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025230340.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025230413.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025230458.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025230607.jpg",
            "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/Creative_03032025230741.jpg"
        ]
    }
];


export const projectsList = [
    {
        id: 1,
        projectName: "Rajpath",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_06042025184955.jpg",
        projectUrl: "/Home/ProjectsDetails?ProjectID=1"
    },
    {
        id: 2,
        projectName: "Awadh City",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025113615.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=2"
    },
    {
        id: 5,
        projectName: "Gomti Green",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025113811.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=5"
    },
    {
        id: 6,
        projectName: "Highway County",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025113842.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=6"
    },
    {
        id: 7,
        projectName: "Rav Residency",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025114208.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=7"
    },
    {
        id: 8,
        projectName: "River Castle",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025114253.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=8"
    },
    {
        id: 3,
        projectName: "Ramodhya",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025113705.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=3"
    },
    {
        id: 4,
        projectName: "Dholera Green City",
        projectLogo: "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/ProjectLogo_02042025113733.png",
        projectUrl: "/Home/ProjectsDetails?ProjectID=4"
    }
];
